export default {
  Admin: 'API.ITC.Admin',
};
